import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { X, Mail, Phone, User, MessageSquare, Send, Check } from 'lucide-react';
import { sendContactForm } from '../services/api';
import './ContactModal.css';

const ContactModal = ({ isOpen, onClose }) => {
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });

  useEffect(() => {
    if (isOpen) {
      const scrollY = window.scrollY;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
    } else {
      const top = document.body.style.top;
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (top) window.scrollTo(0, parseInt(top || '0') * -1);
    }
    return () => {
      const top = document.body.style.top;
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (top) window.scrollTo(0, parseInt(top || '0') * -1);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError('');
    try {
      await sendContactForm(form);
      setSent(true);
    } catch (err) {
      setError('Mesaj gönderilemedi. Lütfen tekrar deneyin.');
    } finally {
      setSending(false);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return ReactDOM.createPortal(
    <div className="contact-overlay" onClick={handleOverlayClick}>
      <div className="contact-modal">
        <button className="contact-modal__close" onClick={onClose}>
          <X size={20} />
        </button>

        {!sent ? (
          <>
            <div className="contact-modal__header">
              <h2 className="contact-modal__title">İletişim</h2>
              <p className="contact-modal__desc">Bize ulaşın, en kısa sürede dönüş yapalım.</p>
            </div>

            <div className="contact-modal__company">
              <p><strong>HireThink Yapay Zeka Teknolojileri A.Ş.</strong></p>
              <p>Bilişim Vadisi, Ayazağa, Vadi Istanbul Park Etabı, Kemerburgaz Caddesi D:7A Blok, 34475 Sarıyer / İstanbul</p>
              <p>Vergi No: 4621090464</p>
            </div>

            <div className="contact-modal__info">
              <div className="contact-modal__info-item">
                <Mail size={14} />
                <span>info@hirethink.ai</span>
              </div>
              <div className="contact-modal__info-item">
                <Phone size={14} />
                <span>0850 307 80 61</span>
              </div>
            </div>

            <form className="contact-modal__form" onSubmit={handleSubmit}>
              <div className="contact-modal__field">
                <div className="contact-modal__input-wrap">
                  <User size={16} className="contact-modal__input-icon" />
                  <input
                    type="text"
                    name="name"
                    className="contact-modal__input"
                    placeholder="Ad Soyad"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="contact-modal__row">
                <div className="contact-modal__field">
                  <div className="contact-modal__input-wrap">
                    <Mail size={16} className="contact-modal__input-icon" />
                    <input
                      type="email"
                      name="email"
                      className="contact-modal__input"
                      placeholder="E-posta"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="contact-modal__field">
                  <div className="contact-modal__input-wrap">
                    <Phone size={16} className="contact-modal__input-icon" />
                    <input
                      type="tel"
                      name="phone"
                      className="contact-modal__input"
                      placeholder="Telefon"
                      value={form.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="contact-modal__field">
                <div className="contact-modal__input-wrap contact-modal__input-wrap--textarea">
                  <MessageSquare size={16} className="contact-modal__input-icon contact-modal__input-icon--top" />
                  <textarea
                    name="message"
                    className="contact-modal__textarea"
                    placeholder="Mesajınız..."
                    rows={4}
                    value={form.message}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {error && <p className="contact-modal__error">{error}</p>}

              <button type="submit" className="contact-modal__submit" disabled={sending}>
                <Send size={16} />
                {sending ? 'Gönderiliyor...' : 'Gönder'}
              </button>
            </form>
          </>
        ) : (
          <div className="contact-modal__sent">
            <div className="contact-modal__sent-icon">
              <Check size={24} />
            </div>
            <h3>Mesajınız Gönderildi!</h3>
            <p>En kısa sürede size dönüş yapacağız. Teşekkür ederiz.</p>
            <button className="contact-modal__sent-btn" onClick={onClose}>
              Kapat
            </button>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default ContactModal;
